import RedactionSearchMultiSelect from './RedactionSearchMultiSelect';

export default RedactionSearchMultiSelect;